module.exports = __webpack_public_path__ + "img/OP ROBOTS.f7d63367.png";